module.exports = __webpack_public_path__ + "img/xiachufang.4e48112e.png";